import { render, staticRenderFns } from "./BadgerAccordion.vue?vue&type=template&id=7fe860ec&"
import script from "./BadgerAccordion.vue?vue&type=script&lang=js&"
export * from "./BadgerAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports